import { useEffect, useRef, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import axios from 'axios'
import { CheckCircle2, XCircle } from 'lucide-react'

// Magic-link landing page. The backend requires POST (so GET prefetchers
// can't falsely confirm) — we fire it once on mount.
export default function CareersConfirm() {
  const { token } = useParams<{ token: string }>()
  const [state, setState] = useState<'pending' | 'ok' | 'bad'>('pending')
  const fired = useRef(false)

  useEffect(() => {
    if (fired.current || !token) return
    fired.current = true
    axios.post(`/careers/api/confirm/${token}/`)
      .then(() => setState('ok'))
      .catch(() => setState('bad'))
  }, [token])

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="max-w-md rounded-lg border p-8 text-center">
        {state === 'pending' && <p className="text-muted-foreground">Confirming your email…</p>}
        {state === 'ok' && (
          <>
            <CheckCircle2 className="mx-auto h-12 w-12 text-green-600" />
            <h1 className="mt-4 text-xl font-semibold">Email confirmed</h1>
            <p className="mt-2 text-muted-foreground">
              Your application is complete. We'll be in touch — thanks for applying.
            </p>
          </>
        )}
        {state === 'bad' && (
          <>
            <XCircle className="mx-auto h-12 w-12 text-destructive" />
            <h1 className="mt-4 text-xl font-semibold">Link invalid or expired</h1>
            <p className="mt-2 text-muted-foreground">
              This confirmation link doesn't match any application.
            </p>
          </>
        )}
        <Link to="/careers" className="mt-6 inline-block text-sm underline">View open positions</Link>
      </div>
    </div>
  )
}
